"use client";

import { Large } from "@/components/ui/typography";
import { cn } from "@/lib/utils";
import React from "react";
// import Marquee from "react-fast-marquee";

const logoItems = [
  // {
  //   logo: "nerdwallet.png",
  //   url: "",
  // },
  {
    logo: "frequent-miler.png",
    url: "https://frequentmiler.com/gondola/",
  },
  {
    logo: "afar.png",
    url: "https://www.afar.com/magazine/we-tested-ai-travel-planning-apps-here-are-the-3-that-actually-worked",
  },
  {
    logo: "ny-times.png",
    url: "https://www.nytimes.com/2025/08/19/travel/ai-travel-tools-test.html",
  },
  {
    logo: "upgraded-points.png",
    url: "https://upgradedpoints.com/news/gondola-hotel-booking-tool/",
  },
  // {
  //   logo: "business-traveler.png",
  //   url: "",
  // },
  {
    logo: "view-wing.png",
    url: "https://viewfromthewing.com/gondolas-ai-unlocks-the-best-hotel-points-deals-and-pays-you-cash-back-when-you-book-direct",
  },
];

const BannerSlider: React.FC = () => {
  return (
    <div className="flex flex-col gap-10 py-10 md:mx-28 md:gap-16 md:py-20">
      <Large className="text-center font-medium text-brand-white opacity-80">
        Read about us in...
      </Large>
      <div className="grid w-full grid-cols-2 items-center justify-items-center gap-4 md:grid-cols-5 md:gap-0">
        {logoItems.map((logo, index) => (
          <button
            className={cn(
              "flex items-center justify-center",
              logo.logo === "view-wing.png" && "hidden md:block"
            )}
            key={index}
            onClick={() => {
              window.open(logo.url, "_blank");
            }}
          >
            <img
              src={`/assets/landing-page/read-about-us/${logo.logo}`}
              alt={logo.logo.replace(/\..+$/, "")}
              className="h-[60px] w-auto object-contain opacity-70 md:h-[85px]"
            />
          </button>
        ))}
      </div>
      {/* <Marquee
        play={false}
        className={cn("w-full", className)}
        direction="right"
      >
        {logoItems.map((logo, index) => (
          <button
            className="flex items-center justify-center"
            key={index}
            onClick={() => {
              window.open(logo.url, "_blank");
            }}
          >
            <img
              src={`/assets/landing-page/read-about-us/${logo.logo}`}
              alt={logo.logo.replace(/\..+$/, "")}
              className="h-[85px] w-auto object-contain opacity-70"
            />
          </button>
        ))}
      </Marquee> */}
    </div>
  );
};

export default BannerSlider;
